import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import withDynamicUrlValidation from "UIComponents/DynamicUrlValidator";
import { injectReducer } from "store/reducers";
import StudentViewDetails from "./routes/StudentViewDetails";
import SubjectViewDetails from "./routes/SubjectViewDetails";
import Insights from "./routes/Insights";
export default store => ({
  path: ":reportId",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "course-progressreport" */ "./components"),
        import(
          /* webpackChunkName: "course-progressreport" */ "ProgressReport/modules/ProgressReportModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "progressReport",
          reducer,
        });
        return withDynamicUrlValidation({
          component,
          urlValidationType: "number",
        });
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    StudentViewDetails(store),
    SubjectViewDetails(store),
    Insights(store),
  ],
});
